<template>
	<div>
		<v-form
		id="editAppointmentForm"
		class="pa-5" 
		ref="form">
		<v-row class="mt-1">
			<v-col cols="8">
				<v-autocomplete
					label="Project"
					v-model="appointment.project"
					:items="projects"
					item-value="id"
					item-text="internalName"
				></v-autocomplete>
				<v-row class="pl-3 pr-3">
					<v-switch v-model="appointment.inheritMethodology" color="success" label="Inherit Methodology" class="pr-2"> </v-switch>
					<v-select
						v-if="!appointment.inheritMethodology"
						v-model="appointment.methodology"
						:items="[{text: 'Face to face', value: 'face-to-face' },{text: 'Video', value: 'video'}, {text: 'Phone', value: 'phone'}] "
					></v-select>
				</v-row>

				<v-row class="pl-3 pr-3" v-if="appointment.methodology == 'face-to-face'">
					<v-switch v-model="appointment.inheritLocation" color="success" label="Inherit Location" class="pr-2"> </v-switch>
					<v-textarea
						class="ml-5"
						v-if="!appointment.inheritLocation"
						v-model="appointment.location"
					></v-textarea>
				</v-row>

				<v-autocomplete
					label="Status"
					v-model="appointment.status"
					:items="statuses"
				></v-autocomplete>

				<v-autocomplete
					label="Quota"
					v-model="appointment.quota"
					:items="quotas"
				></v-autocomplete>

				<v-autocomplete
					label="Participant"
					v-model="appointment.participant"
					:items="panelists" 
					item-value="id"
					item-text="displayName" 
				></v-autocomplete>

				<v-text-field v-for="additionalField in project.additionalFields" :key="additionalField" v-model="appointment[additionalField]" :label="additionalField"></v-text-field>

				<v-textarea
					v-model="appointment.notes"
					label="Notes"
				></v-textarea>
			<Recordings :appointment="appointment"></Recordings>
			</v-col>
			<v-col>
				<v-date-picker v-model="date" class="mr-5"  @input="menu2 = false"></v-date-picker><br/>
				<v-time-picker class="mt-3" format="24hr" v-model="time"></v-time-picker>
			</v-col>			
		</v-row>
		<v-btn
		color="green" 
		dark
		class="mr-4"
		@click="save"
		>Save
		</v-btn>
		</v-form> 
	</div>
</template>

<script>
import Vue from "vue";
import Vuex from 'vuex'


import {formatDateTime}   from "../../assets/utilities.js";
import Recordings from "../communication/video/Recordings.vue"
export default {
  name: 'EditAppointment',
  props: ["appointment"],
  data: () => ({
		date: '',
		time: '', 
    }),
	computed: {
		...Vuex.mapState({
			view: state => state.auth.view,
			statuses: state => state.settings.statuses,
			projects: state => state[state.auth.view].projects,
			clients: state => state[state.auth.view].clients,
			panelists: state => state[state.auth.view].panelists,
		}),
		project(){
			let projectId = this.appointment.project;
			let project = this.projects.find( p => p.id == projectId)
			return project			
		},
		quotas: function(){
			if( this.project ){ return this.project.quotas; }
			return [];
		}
	},
	methods: {
		save() {
			var self = this;
			let update = {};
			for( var key in self.appointment ){
				update[key] = self.appointment[key];	
			}
			this.$store.dispatch("updateDoc", {
				doc: "appointments/" + self.appointment.id,
				data: update, 
				action: "update" 
			}).then( () => {
				self.$emit("saved");
			}) 
		}
	},
	components: {
		Recordings: Recordings
	},
	watch:{
		date: function(){
			var dateTime = formatDateTime( this.date, this.time );
			this.appointment.dateTime = dateTime;
		},
		time: function(){
			var dateTime = formatDateTime(this.date, this.time ) ;
			this.appointment.dateTime = dateTime;
		},
		appointment: {
			immediate: true,
			handler: function( ){
				if( !this.appointment.dateTime ){ return; }

				this.date = Vue.moment(this.appointment.dateTime.toDate()).format("YYYY-MM-DD")
				this.time = Vue.moment(this.appointment.dateTime.toDate()).format("HH:mm");
				if( this.appointment.project ){
					this.$store.dispatch( 'bindProject', this.appointment.project );
					
				}
			}
		},
		inheritMethodology(inherit ){
			if( inherit ){
				this.appointment.methodology = this.project.methodology;
			}
		},
		inheritLocation(inherit ){
			if( inherit ){
				this.appointment.location = this.project.location;
			}
		},
	},	
	created(){
	},
	destroyed: function(){
		// this.$store.dispatch( 'unbindProjectInfo' );
	}

};

</script>
